export default "__VITE_ASSET__DWE9yMAF__"